<template>
    <div>
        <Navbar v-if="this.$route.name=='examcorrection'"/>
        <Breadcrumb v-if="this.$route.name=='examcorrection'" /> 
        <div v-if="currentexamid==0">
            <b-row>
                <b-col>
                    <b-card title="Exam Correction" class="my-3">
                        <label>Correct exams for teacher:</label>
                        <b-form-select
                            v-model="teacher_id"
                            @change="myexams_get"
                            :options="teachers"
                            :placeholder="'Select Course'"
                        />
                        <b-table striped hover :items="myexams" :fields="myexamcolumns">
                            <template v-slot:cell(actions)="data">
                                <b-button size="sm" variant="primary" @click="currentStudentId=data.item._consultant_id;currentCourseId = data.item._course_id;currentexamid = data.item._exam_id">Correct</b-button>
                            </template>
                        </b-table>
                    </b-card>
                </b-col>
            </b-row>
        </div>
        <div v-if="currentexamid!==0">
            <ExamCorrectionDetail
                :examId="currentexamid"
                :consultantId="currentStudentId"
                :courseId="currentCourseId"
                :resetCourse="resetCourse"
            />
        </div>
    </div>
</template>
<script>
import Navbar from './Navbar.vue';
import Breadcrumb from './Breadcrumb.vue';
import ExamCorrectionDetail from './ExamCorrectionDetail.vue';

const myexamcolumns = [
    { key: 'id', label: 'ID', sortable: false, thClass: 'd-none', tdClass: 'd-none' },
    { key: 'consultant_id', label: 'Consultant', sortable: true },
    { key: 'exam_id', label: 'Exam', sortable: true },
    { key: 'actions', label: 'Actions' }
];

export default {
    name: 'ExamCorrection',
    components: {
        Navbar,
        Breadcrumb,
        ExamCorrectionDetail,
    },
    data()  {
        return {
            myexams: [],
            currentCourseId: 0,
            currentexamid: 0,
            currentStudentId: 0,
            teachers: [],
            teacher_id: this.$store.state.user_id,
            myexamcolumns,
        }
    },
    created() {
        this.teachers_get();
        this.myexams_get();
        this.currentexamid = 0;
    },  
    methods: {
        resetCourse() {
            // Your logic to reset the course
            this.currentexamid = 0;
            this.currentStudentId = null;
            this.currentCourseId = null;
        },
        async teachers_get() {
            const teachers = this.$store.dispatch('records_readlist', {
                table_name: 'i_user',
                filter: {},
                sort: 'id',
                order: 'DESC',
                page: 1,
                perPage: 1000
            })
            .then(response => {
                this.teachers = 
                    response.data.result
                    .filter(item => 
                        ([
                            'qbjorn@gmail.com',
                        ].includes(item.email) ||
                        item.email.indexOf('gdq.se') > -1
                        )
                    )
                    .map(item => {
                    return {
                        value: item.id,
                        text: item.email
                    }
                });
            })
            .catch(error => {
                console.log(error);
            });
        },
        async myexams_get() {
            const modulesfilter = {
                module_teacher_id: {
                    value: this.teacher_id,
                    operator: '='
                },
                exam_id: {
                    value: '0',
                    operator: '!='
                },
            }
            const modules = this.$store.dispatch('records_readlist', {
                table_name: 'g_elearning_modules',
                filter: modulesfilter,
                sort: 'id',
                order: 'DESC',
                page: 1,
                perPage: 1000
            })
            .then(response => {
                const examids = response.data.result.map(item => item.exam_id);
                const examsfilter = {
                    _exam_id: {
                        value: examids.join(','),
                        operator: 'IN'
                    }, 
                }
                const consultantexams = this.$store.dispatch('records_readlist', {
                    table_name: 'g_elearning_consultant_exams',
                    filter: examsfilter,
                    sort: 'id',
                    order: 'DESC',
                    page: 1,
                    perPage: 1000
                })
                .then(response => {
                    this.myexams = response.data.result;
                })
                .catch(error => {
                    console.log(error);
                });
            })
        },
    },
}
</script>
<style>
</style>